import React from 'react';
import { arrayOf, func } from 'prop-types';
import { paymentMethodType, skuType } from 'types';
import * as yup from 'yup';

import get from 'lodash/get';

import { Elements, StripeProvider } from 'react-stripe-elements';
import FormWrapper from 'components/FormWrapper';
import { CSS_OVERFLOW, STRIPE_PUBLIC_API_KEY } from 'utils/constants';

import InnerForm from './innerForm';

const validationSchema = yup.object().shape({
  paymentMethodId: yup.string().required('(required)'),
  orderData: yup.object().nullable(),
  skuAmount: yup.number().required('(required)'),
  skuId: yup.string().required('(required)')
});

// Stripe's `<Elements>` wrapper is required even though we aren't using them explicitly.
// See https://github.com/stripe/react-stripe-elements/issues/214
const CreditsPurchaseForm = ({ hideModal, onSubmit, paymentMethods, skus }) => (
  <StripeProvider apiKey={STRIPE_PUBLIC_API_KEY}>
    <Elements>
      <FormWrapper
        formName="Purchase Credit"
        handleSubmit={() => {}}
        initialValues={{
          orderData: null,
          paymentMethodId: get(paymentMethods, [0, 'id']),
          // TODO: if we want to allow purchasing multiple types of credits at once,
          //  investigate https://jaredpalmer.com/formik/docs/guides/arrays
          skuAmount: 1,
          skuId: get(skus, [0, 'sku_id'])
        }}
        overflowBehaviour={CSS_OVERFLOW.VISIBLE}
        validationSchema={validationSchema}
      >
        <InnerForm
          hideModal={hideModal}
          onSubmit={onSubmit}
          paymentMethods={paymentMethods}
          skus={skus}
        />
      </FormWrapper>
    </Elements>
  </StripeProvider>
);

CreditsPurchaseForm.propTypes = {
  hideModal: func.isRequired,
  onSubmit: func.isRequired,
  paymentMethods: arrayOf(paymentMethodType),
  skus: arrayOf(skuType)
};

export default CreditsPurchaseForm;
